class PersonalRequestDTO {
    constructor({ id, fullName, cpf, phone, email, taxId, step }) {
		this.id = id;
        this.fullName = fullName;
        this.cpf = cpf;
        this.phone = phone;
        this.email = email;
        this.taxId = taxId;
        this.step = step;
    }
};

export default PersonalRequestDTO;